<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-16 09:39:27
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-18 11:07:40
 * @name: 我的售后
 * @Description: 我的售后
 * @FilePath: \preSaleNafterSaleInside\project\src\views\index\afterSale\afterSaleRouter.vue
 * @Author: desktop
-->
<template>
  <div class="afterSaleRouter">
    <keep-alive :include="cashRouters">
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
export default {
  name: "indexAfterSale",
  computed: {
    cashRouters() {
      return this.$store.state.cashView.cashRouters;
    },
  },
};
</script>
<style lang="scss" scoped>
.afterSaleRouter {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
</style>